// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"CAMPS-module--previewTitle--2G0--","tag":"CAMPS-module--tag--QqCwe"};